// Real photos from Emanuela Serena's archive (Google Drive import), optimized into /public/images.
export const IMAGES = {
  heroMain: "/images/hero-main-new.jpg",
  heroSecondary: "/images/hero-secondary.jpg",
  heroTertiary: "/images/bab-product.jpg",
  atelierFurnace: "/images/sketch-bab.jpg",
  atelierBench: "/images/sketch-feel.jpg",
};
